import { createApi } from '@reduxjs/toolkit/query/react';

import deserialize from '../helpers/getroPropertyMapper';
import { baseQuery } from './queries';

export const userGoogleAccountsApi = createApi({
  reducerPath: 'userGoogleAccountsApi',
  baseQuery,
  tagTypes: ['google-accounts'],
  endpoints: (builder) => ({
    getUserGoogleAccounts: builder.query({
      query: () => ({ url: '/user_google_accounts', options: { version: 'v2' } }),
      transformResponse: deserialize,
      providesTags: ['google-accounts'],
    }),
    createUserGoogleAccount: builder.mutation({
      query: ({ code, preferences }) => ({
        url: '/user_google_accounts',
        method: 'POST',
        data: {
          code,
          ...(preferences ?? {}),
        },
        options: { version: 'v2' },
      }),
      transformResponse: deserialize,
      invalidatesTags: ['google-accounts'],
    }),
    updateUserGoogleAccount: builder.mutation({
      query: ({ id, ...attrs }) => ({
        url: `/user_google_accounts/${id}`,
        method: 'PATCH',
        data: attrs,
        options: { version: 'v2' },
      }),
      transformResponse: deserialize,
      invalidatesTags: ['google-accounts'],
    }),
    deleteUserGoogleAccount: builder.mutation({
      query: ({ id }) => ({ url: `/user_google_accounts/${id}`, method: 'DELETE', options: { version: 'v2' } }),
      invalidatesTags: ['google-accounts'],
    }),
  }),
});

export const {
  useGetUserGoogleAccountsQuery,
  useLazyGetUserGoogleAccountsQuery,
  useCreateUserGoogleAccountMutation,
  useUpdateUserGoogleAccountMutation,
  useDeleteUserGoogleAccountMutation,
} = userGoogleAccountsApi;
